import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "../components/ui/input";
import { LogoMark } from "../components/site/Logo";
import { api, formatApiError } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main id="main-content" className="flex min-h-screen items-center justify-center bg-[#F4F1EA] px-5 pt-20" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md rounded-[2rem] border border-[#E2DCD0] bg-[#FDFBF7] p-8 sm:p-10">
        <LogoMark className="h-12 w-12" />
        <h1 className="font-serif-display mt-6 text-4xl">Team sign in</h1>
        <p className="mt-2 text-sm text-[#4A554D]">Private area for reviewing contact requests.</p>
        <div className="mt-8 space-y-4">
          <Input type="email" placeholder="Email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl" data-testid="login-email-input" />
          <Input type="password" placeholder="Password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-xl" data-testid="login-password-input" />
        </div>
        {error && <p className="mt-4 text-sm text-[#B42318]" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={busy} className="mt-6 flex h-12 w-full items-center justify-center rounded-full bg-[#1E2621] text-sm font-medium text-[#F4F1EA] hover:bg-[#A9533A] disabled:opacity-60" data-testid="login-submit-button">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}
        </button>
      </form>
    </main>
  );
}
